var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-autocomplete',{ref:"branch_id",staticClass:"text-sm",attrs:{"data-pptr":"branch","background-color":"white","error":_vm.hasErrorStore || _vm.error,"error-messages":_vm.errorMessages,"items":_vm.branchItems,"disabled":_vm.isDisabledSelectBranch,"filter":function (item, queryText, itemText) {
        var text = "" + (item.text)
        return (
          text
            .toLocaleLowerCase()
            .indexOf(queryText.toLocaleLowerCase()) > -1
        )
      },"item-text":"text","item-value":"id","placeholder":"เลือกสาขา"},on:{"change":_vm.change},model:{value:(_vm.branchId),callback:function ($$v) {_vm.branchId=$$v},expression:"branchId"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }